require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_8.9.1/lib/node_modules/@core/macys-cli/node_modules/core-js/fn/regexp/escape.js
// module id = 335
// module chunks = 0